/*
  Wrap original DataTable into a modal to avoid overlappings, when the
  form block lives within a column (of a column block).
*/
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon, Modal } from 'semantic-ui-react';
import DataTableOrig from 'volto-form-block-original/components/DataTable';

const DataTable = (props) => {
  const [modalOpen, setModalOpen] = useState(true);
  return (
    <>
      <Button
        onClick={() => {
          setModalOpen(true);
        }}
        icon
      >
        <Icon name="eye" />{' '}
        <FormattedMessage id="Show data" defaultMessage="Show data" />
      </Button>
      <Modal
        size="fullscreen"
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
        style={{ padding: '20px' }}
      >
        <DataTableOrig {...props} />
        <br />
        <Button
          onClick={() => {
            setModalOpen(false);
          }}
          icon
        >
          <Icon name="close" />
          <FormattedMessage id="Close" defaultMessage="Close" />
        </Button>
      </Modal>
    </>
  );
};

export default DataTable;
